import { useMutation } from "@tanstack/react-query";
import { IClassCategory } from "../../models/ClassCategory";
import { ClassCategoryService } from "../../services/class-category.service";

export const useClassCategoryMutations = () => {
  const { mutate: createCategory } = useMutation<any, Error, Omit<IClassCategory, "id">>({
    mutationFn: async (model) => ClassCategoryService.create(model),
  });

  const { mutate: updateCategory } = useMutation<
    any,
    Error,
    { id: string; model: Omit<IClassCategory, "id"> }
  >({
    mutationFn: async ({ id, model }) => ClassCategoryService.update(id, model),
  });

  return {
    createCategory,
    updateCategory,
  };
};
